










































import { Vue, Component } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { mapState } from 'vuex';
import ClientModel from '@/models/crm/client.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import SettingsModel from '@/models/crm/settings.model';
import SettingsService from '@/services/crm/settings.service';
import ConversationUserPermissionsModel from '@/models/crm/conversation-user-permissions.model';
import ConversationService from '@/services/crm/conversation.service';
import ClientManagementModel from '@/models/crm/client-management.model';
import ClientManagementService from '@/services/crm/client-management.service';
import OriginModel from '@/models/crm/origin.model';
import ResponsibleAttendantModel from '@/models/crm/responsible-attendant.model';
import GeoChatClientDetailsCard from '@/components/crm/geochat-client-details-card.vue';
import GeoChat from '@/components/crm/geochat-chat.vue';
import ConversationModel from '@/models/crm/conversation.model';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import { IKeyValue } from '@/interfaces/key-value.interface';
import ContentDialog from '../content-dialog.vue';
import { ICreateConversation } from '@/interfaces/crm/create-conversation.interface';
import ContactModel from '@/models/crm/contact.model';

@Component({
  components: { GeoChat, GeoChatClientDetailsCard, ContentDialog },
  computed: {
    ...mapState(['activeClient', 'createConversationPayload', 'userContactInfo']),
  },
})
export default class GeoChatMain extends Vue {
  @inject('CrmSettingsService') private settingsService!: SettingsService;

  @inject('CrmConversationService') private conversationService!: ConversationService;

  @inject('CrmClientManagementService') private clientManagementService!: ClientManagementService;

  dialogConfig: IKeyValue<IDialogConfig> = {
    confirmation: {
      message: '',
      color: '',
      show: false,
      onChoice: () => {},
    },
    sendEmail: {
      show: false,
    },
    particularities: {
      show: false,
      editing: false,
      saving: false,
      description: '',
    },
  };

  createConversation: ICreateConversation | null = null;

  origemType: string | undefined | null = null;

  client: ClientModel | null = null;

  selectedClientId: string | null = null;

  showClientDetails = false;

  clientDetailsActionsLoading = false;

  attendantsList: ResponsibleAttendantModel[] = [];

  allClientManagements: ClientManagementModel[] = [];

  clientNotIntegrated = false;

  channelOptions: OriginModel[] = [];

  loading = false;

  conversationUserPermission: ConversationUserPermissionsModel | null = null;

  openActiveConversation = false;

  mainContactInfo: ContactModel | undefined;

  settings: SettingsModel | null = null;

  get clientId(): string | null {
    if (this.$store.getters.getClientId) {
      return this.$store.getters.getClientId?.toString() || null;
    }
    return null;
  }

  set clientId(newClientId: string | null) {
    this.$store.commit('setClientId', newClientId);
  }

  get activeClient(): ClientModel | null {
    if (this.$store.getters.getActiveClient) {
      return this.$store.getters.getActiveClient;
    }
    return null;
  }

  get createConversationPayload(): ICreateConversation | null {
    if (this.$store.getters.getConversationPayload) {
      return this.$store.getters.getConversationPayload;
    }
    return null;
  }

  get userContactInfo(): UserContactInfo | null {
    if (this.$store.getters.getUserInfo) {
      return this.$store.getters.getUserInfo;
    }

    return null;
  }

  get clientType(): string | null {
    return this.$store.state.clientType;
  }

  async mounted() {
    this.openActiveConversation = Boolean(this.$route.params?.clientId || this.$route.query?.clientId
    || this.$route.params?.conversationId || this.$route.query?.conversationId);

    await this.loadInitialData();
  }

  private async loadInitialData() {
    // Cargas independentes em paralelo (mesma apresentação, sem cascata sequencial).
    const tasks: Promise<void>[] = [];

    if (!this.settings) {
      tasks.push(this.settingsService.getSettings().then((result) => {
        this.settings = result;
      }));
    }

    if (!this.conversationUserPermission) {
      tasks.push(this.conversationService.getUserPermissions().then((result) => {
        this.conversationUserPermission = result;
      }));
    }

    if (this.activeClient) {
      tasks.push(this.clientManagementService.getClientsManagement(this.activeClient.cnpjCpf)
        .then((result) => {
          this.allClientManagements = result;
        }));
    }

    await Promise.all(tasks);
  }

  stopLoading() {
    this.loading = false;
  }

  handleClientInfo(show: boolean) {
    this.showClientDetails = show;
  }

  toggleCurrentClientInfo() {
    this.showClientDetails = !this.showClientDetails;
  }

  async onConversationSelected(conversation: ConversationModel) {
    if (conversation.cliente && conversation.cliente.id) {
      this.clientId = conversation.cliente.id.toString();
      this.origemType = conversation.cliente.origemCadastro?.toString();
    } else if (conversation.prospect && conversation.prospect.cnpj) {
      this.clientId = conversation.prospect.cnpj.replace(/\D/g, '');
      this.origemType = conversation.prospect.origemCadastro?.toString();
    }
  }
}
